import { eraseCookie } from '@jouzen/ecom-utils';
import { useTranslations } from 'next-intl';
import { useState } from 'react';

import { resetAccount } from '@/lib/account/accountSlice';
import { useAppDispatch } from '@/lib/hooks';

import SubmitButton from '../SubmitButton';

const NotFound = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const t = useTranslations();
  const dispatch = useAppDispatch();
  const resetEmailForm = () => {
    setLoading(true);
    eraseCookie('session');
    eraseCookie('id_token');
    dispatch(resetAccount());

    //needed to ensure the auth is reinstantiated
    window.location.replace('/');
  };

  return (
    <SubmitButton
      loading={loading}
      onClick={() => resetEmailForm()}
      full
      type="submit"
    >
      {t('my_account_another_email')}
    </SubmitButton>
  );
};
export default NotFound;
